import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uk-container uk-margin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "uk-text-left uk-padding uk-card uk-card-default" }
const _hoisted_4 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-3@m" }
const _hoisted_5 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-3@m" }
const _hoisted_6 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-3@m" }
const _hoisted_7 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-1@m" }
const _hoisted_8 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-3@m" }
const _hoisted_9 = { class: "uk-grid" }
const _hoisted_10 = { class: "uk-grid uk-child-width-1-1@s uk-child-width-1-3@m" }
const _hoisted_11 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_12 = { class: "uk-card uk-card-default uk-card-body" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: ""
}
const _hoisted_15 = { class: "uk-text-danger uk-text-large" }
const _hoisted_16 = { class: "uk-text-danger uk-text-large" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AddressInputBlock = _resolveComponent("AddressInputBlock")!
  const _component_Button = _resolveComponent("Button")!
  const _component_UploadButton = _resolveComponent("UploadButton")!

  return (!_ctx.mainLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, "Onboarding for " + _toDisplayString(_ctx.onboarderCompany.name), 1),
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logo.docFileUrl,
              class: "uk-margin-bottom"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _cache[41] || (_cache[41] = _createElementVNode("section", { class: "uk-section uk-section-primary" }, [
          _createElementVNode("h3", null, "Basic Info")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_InputField, {
              label: "Company name (*required)",
              modelValue: _ctx.companyInfo.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyInfo.name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Email (*required)",
              modelValue: _ctx.companyInfo.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyInfo.email) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "MC # (*required)",
              modelValue: _ctx.companyInfo.mcNum,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyInfo.mcNum) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "DOT # (*required)",
              modelValue: _ctx.companyInfo.dotNum,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyInfo.dotNum) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "FID #",
              modelValue: _ctx.companyInfo.fidNum,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyInfo.fidNum) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_InputField, {
              label: "Primary Contact Name",
              modelValue: _ctx.companyInfo.primaryContactName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyInfo.primaryContactName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Primary Contact Phone #",
              modelValue: _ctx.companyInfo.primaryContactPhoneNumber,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyInfo.primaryContactPhoneNumber) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Accounting Email",
              modelValue: _ctx.companyInfo.accountingEmail,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyInfo.accountingEmail) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InputField, {
              label: "Dispatch phone #",
              modelValue: _ctx.companyInfo.dispatchPhone,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyInfo.dispatchPhone) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "After-hours phone # (*required - for emergency only)",
              modelValue: _ctx.companyInfo.afterHoursPhone,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyInfo.afterHoursPhone) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Fax #",
              modelValue: _ctx.companyInfo.faxNumber,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.companyInfo.faxNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AddressInputBlock, {
              requiredLabel: "(*required)",
              address: _ctx.companyInfo.officeAddress
            }, null, 8, ["address"])
          ]),
          _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputField, {
              label: "Number of owner/operator drivers",
              modelValue: _ctx.companyInfo.numOwnerOpDrivers,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.companyInfo.numOwnerOpDrivers) = $event)),
              modelModifiers: { number: true },
              type: "number"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Number of company drivers",
              modelValue: _ctx.companyInfo.numCompanyDrivers,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyInfo.numCompanyDrivers) = $event)),
              modelModifiers: { number: true },
              type: "number"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              label: "Preferred lanes",
              modelValue: _ctx.companyInfo.preferredLanes,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyInfo.preferredLanes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "tlcheck",
                class: "uk-form-label"
              }, "We transport TL", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tlcheck",
                type: "checkbox",
                label: "TL",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.companyInfo.doesTransportTl) = $event)),
                class: "uk-input uk-form-controls uk-checkbox small-left-margin"
              }, null, 512), [
                [_vModelCheckbox, _ctx.companyInfo.doesTransportTl]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                for: "ltlcheck",
                class: "uk-form-label"
              }, "We transport LTL", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ltlcheck",
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.companyInfo.doesTransportLtl) = $event)),
                class: "uk-input uk-form-controls uk-checkbox small-left-margin"
              }, null, 512), [
                [_vModelCheckbox, _ctx.companyInfo.doesTransportLtl]
              ])
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputField, {
              label: "Number of tractors",
              modelValue: _ctx.companyInfo.numTractors,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.companyInfo.numTractors) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 45' flat/vans",
              modelValue: _ctx.companyInfo.num45FlatVans,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyInfo.num45FlatVans) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 48' flat/vans",
              modelValue: _ctx.companyInfo.num48FlatVans,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.companyInfo.num48FlatVans) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 53' flat/vans",
              modelValue: _ctx.companyInfo.num53FlatVans,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.companyInfo.num53FlatVans) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of reefers",
              modelValue: _ctx.companyInfo.numReefers,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.companyInfo.numReefers) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of step decks",
              modelValue: _ctx.companyInfo.numStepDecks,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.companyInfo.numStepDecks) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 4' tarps",
              modelValue: _ctx.companyInfo.num4Tarps,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.companyInfo.num4Tarps) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 6' tarps",
              modelValue: _ctx.companyInfo.num6Tarps,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.companyInfo.num6Tarps) = $event)),
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of 8' tarps",
              modelValue: _ctx.companyInfo.num8Tarps,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.companyInfo.num8Tarps) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of coil racks",
              modelValue: _ctx.companyInfo.numCoilRacks,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.companyInfo.numCoilRacks) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_InputField, {
              label: "Number of pipe stakes",
              modelValue: _ctx.companyInfo.numPipeStakes,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.companyInfo.numPipeStakes) = $event)),
              modelModifiers: { number: true },
              class: _normalizeClass(_ctx.classesEquipInfo),
              type: "number"
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("button", {
          class: "uk-button uk-button-large uk-button-primary uk-form-controls uk-margin-top uk-width-1-3 large-button",
          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.saveOnboardingInfo && _ctx.saveOnboardingInfo(...args)))
        }, [...(_cache[37] || (_cache[37] = [
          _createElementVNode("div", null, "Save", -1)
        ]))]),
        _cache[42] || (_cache[42] = _createElementVNode("section", { class: "uk-section uk-section-secondary uk-margin-top" }, [
          _createElementVNode("h3", { class: "" }, "Documents to Fill and Sign")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoDocsReqSig, (doc) => {
          return (_openBlock(), _createElementBlock("div", {
            key: doc.id,
            class: "uk-card uk-card-default uk-card-body"
          }, [
            _createVNode(_component_Button, _mergeProps({ ref_for: true }, 
          _ctx.docsSigningIsCompleted[doc.docType]
            ? { isGray: 'true' }
            : { isRed: 'true' }
        , {
              isMediumText: true,
              onClick: ($event: any) => (_ctx.showSignForm(doc.docType))
            }), {
              default: _withCtx(() => [
                _createTextVNode(" Sign " + _toDisplayString(_ctx.displayDocTypeName(doc.docType)), 1)
              ]),
              _: 2
            }, 1040, ["onClick"]),
            (_ctx.docsSigningIsCompleted[doc.docType])
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("span", {
                    "uk-icon": "icon: check; ratio: 1.4",
                    class: "uk-margin-small-right"
                  }, null, -1),
                  _createTextVNode(" Completed! ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _cache[43] || (_cache[43] = _createElementVNode("section", { class: "uk-section uk-section-muted uk-margin-top" }, [
          _createElementVNode("h3", null, "Upload Your Documents"),
          _createElementVNode("p", null, "PDF files only")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.uploadLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[39] || (_cache[39] = [
                _createElementVNode("div", { "uk-spinner": "ratio: 5" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(this.loadFormError), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toUploadDocumentTypes, (toUploadDoc, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "uk-flex uk-flex-center"
                  }, [
                    (_ctx.docsToUploadIsUploaded[toUploadDoc.docType])
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_UploadButton, {
                            onFileUploaded: 
                (event) => _ctx.uploadOnboardingDocument(toUploadDoc.docType, event)
              ,
                            uploadText: 
                'Re-Upload ' + _ctx.displayDocTypeName(toUploadDoc.docType)
              ,
                            isGray: true
                          }, null, 8, ["onFileUploaded", "uploadText"]),
                          _cache[40] || (_cache[40] = _createElementVNode("div", null, "Uploaded!", -1))
                        ], 64))
                      : (_openBlock(), _createBlock(_component_UploadButton, {
                          key: 1,
                          onFileUploaded: 
                (event) => _ctx.uploadOnboardingDocument(toUploadDoc.docType, event)
              ,
                          uploadText: 
                'Upload ' +
                _ctx.displayDocTypeName(toUploadDoc.docType) +
                (toUploadDoc.required ? ' (*required)' : ' (optional)')
              ,
                          isMediumText: true,
                          isRed: true
                        }, null, 8, ["onFileUploaded", "uploadText"]))
                  ]))
                }), 128))
              ]))
        ]),
        _createElementVNode("button", {
          class: "uk-button uk-button-large uk-button-primary uk-form-controls uk-margin-top uk-text-large",
          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.submitOnboardingInfo && _ctx.submitOnboardingInfo(...args)))
        }, " Submit Onboarding "),
        _createElementVNode("p", _hoisted_16, _toDisplayString(this.submitError), 1)
      ]))
    : _createCommentVNode("", true)
}